<template>
    <div class="accordion__body">
        <div class="item">
            <button class="item__title" @click="toggle" :class="{ 'is-active': isActive }">
                Downloads
                <span class="icon"></span>
            </button>
            <Transition name="accordion" @enter="enter" @after-enter="afterEnter" @leave="leave">
                <div class="item__body" v-if="isActive">
                    <template v-for="(item, index) in items" :key="`item-${index}`">
                        <a class="download-item" :href="item.Url" :target="item.Target">
                            <svgComponent
                                :width="24"
                                :height="24"
                                class-name="icon-download"
                                icon-name="icon-download"></svgComponent>
                            <span class="title">{{ item.Text }}</span>
                        </a>
                    </template>
                </div>
            </Transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import svgComponent from '../../../components/svgComponent.vue';

interface IDownloadItem {
    Text: string;
    Url: string;
    Target: string;
    Active: boolean;
}

defineProps<{
    items: IDownloadItem[];
}>();

const isActive: Ref<boolean> = ref(false);

const toggle = () => {
    isActive.value = !isActive.value;
};

const enter = (el: HTMLElement) => {
    el.style.height = 'auto';

    const height = getComputedStyle(el).height;
    el.style.height = '0';

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = height;
    });
};

const afterEnter = (el: HTMLElement) => {
    el.style.height = 'auto';
};

const leave = (el: HTMLElement) => {
    el.style.height = getComputedStyle(el).height;

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = '0';
    });
};
</script>
